import React from 'react';
import { RefreshCw, Sparkles } from 'lucide-react';
import { Button } from '../ui/Button';
import { Skeleton } from '../ui/Skeleton';
import { dailyBriefSets } from '../../data/insights';
import { useAiRun } from '../../hooks/useAiRun';
const RUN_STAGES = ['Reading portfolio state', 'Comparing against historical outcomes', 'Drafting insight summary'];
const toneClasses: Record<string, string> = {
  positive: 'text-[#7fe0b6]',
  watch: 'text-[#f0c94f]',
  risk: 'text-[#ff9d9b]'
};
export function AiDailyBrief() {
  const [setIndex, setSetIndex] = React.useState(0);
  const run = useAiRun({
    stages: RUN_STAGES,
    stageDuration: 650
  });
  const insights = dailyBriefSets[setIndex % dailyBriefSets.length];
  React.useEffect(() => {
    if (run.state === 'complete') {
      setSetIndex(index => index + 1);
      run.reset();
    }
  }, [run]);
  const running = run.state === 'running';
  return <section className="rounded-sm bg-uae-green p-4 text-white" data-id="element-26" data-mp="180b5pxz3dm0q">
      <div className="flex items-start justify-between gap-3" data-id="element-27" data-mp="14newncksqme4">
        <div data-id="element-28" data-mp="14mvouoov1edt">
          <h2 className="flex items-center gap-1.5 text-[13px] font-semibold" data-id="element-29" data-mp="14lavh2ea81hj">
            <Sparkles className="h-4 w-4" aria-hidden="true" data-id="element-30" data-mp="19kx7j8idjbor" />
            AI daily brief
          </h2>
          <p className="mt-1 text-[11px] text-white/55" data-id="element-31" data-mp="1edqcnxhr8m1d">
            Generated across the live pipeline, gates and outreach delivery
          </p>
        </div>
        <Button variant="ghost" size="xs" onClick={run.start} disabled={running} className="text-white/75 hover:bg-white/10 hover:text-white" data-id="element-32" data-mp="lp2pfwdg3ml6">
          <RefreshCw className={`mr-1 h-3 w-3 ${running ? 'animate-spin' : ''}`} aria-hidden="true" data-id="element-33" data-mp="uoy265mnfpnb" />
          {running ? 'Generating' : 'Regenerate'}
        </Button>
      </div>

      {running ? <div className="mt-4 space-y-3" aria-live="polite" data-id="element-34" data-mp="263uwnv1lr722">
          {[0, 1, 2].map(index => <div key={index} className="rounded-sm bg-white/5 p-3" data-id="element-35" data-mp="2b1mkacv7s70g">
              <Skeleton className="h-3 w-2/3 bg-white/10" data-id="element-36" data-mp="b06k5z2jba3v" />
              <Skeleton className="mt-2 h-3 w-full bg-white/10" data-id="element-37" data-mp="6zmo6ytp6cjb" />
              <Skeleton className="mt-1.5 h-3 w-4/5 bg-white/10" data-id="element-38" data-mp="6z37tmjp3w7e" />
            </div>)}
          <p className="text-[11px] text-white/60" data-id="element-39" data-mp="kyvsp18jji7g">{run.currentStage}…</p>
        </div> : <ul className="mt-4 space-y-2.5" data-id="element-40" data-mp="g0u82bvgvatv">
          {insights.map(insight => <li key={insight.id} className="rounded-sm bg-white/5 p-3" data-id="element-41" data-mp="3ogw3sp9e83pa">
              <div className="flex items-start justify-between gap-3" data-id="element-42" data-mp="3jhjgk3em0um6">
                <p className="text-[12px] font-medium leading-snug text-white" data-id="element-43" data-mp="3jf6qt42m1fyk">
                  <span className={`mr-1.5 ${toneClasses[insight.tone]}`} aria-hidden="true" data-id="element-44" data-mp="21uo3hiwfk41">
                    ●
                  </span>
                  {insight.label}
                </p>
                <span className="shrink-0 font-mono text-[10px] text-white/50" data-id="element-45" data-mp="35ns8kzgj1isk">
                  {insight.confidence}%
                </span>
              </div>
              <p className="mt-1.5 text-[11px] leading-relaxed text-white/60" data-id="element-46" data-mp="1g891sqr46wi8">{insight.detail}</p>
            </li>)}
        </ul>}
    </section>;
}